import { render, staticRenderFns } from "./customerCountTable.vue?vue&type=template&id=6f23f4ed"
import script from "./customerCountTable.vue?vue&type=script&lang=js"
export * from "./customerCountTable.vue?vue&type=script&lang=js"
import style0 from "./customerCountTable.vue?vue&type=style&index=0&id=6f23f4ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports